import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import EmployeeCard from "molecules/EmployeeCard";
import {
  Row,
  Col,
  Select,
  Button,
  Spin,
  Modal,
  Tabs,
  message,
  Empty,
  Dropdown,
  Pagination,
  Form,
} from "antd";
import { DEVICE } from "common/Device";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { reduce, uniqBy } from "lodash";
import { CSVLink } from "react-csv";
import {
  getUserList,
  getUserRoleId,
  getAllDepartmentList,
  getDepartmentUserList,
  getSelectedDepartmentId,
  getClientid,
  getMenuList,
  getFilters,
  getLocations,
} from "redux/selectors";
import { setUserList, setFilter } from "redux/actions";
import styled from "@emotion/styled";
import { CALL_API, CALL_API_WITH_HEADER } from "common/API";
import { map, concat } from "lodash";
import Icon from "atoms/Icon";
import AddEmployee from "organisms/AddEmployee";
import EditEmployee from "organisms/EditEmployee";
import Confirm from "../../src/assets/Confirm.svg";
import { countryList, STATUS_CODE } from "common/Constants";
import { bindActionCreators } from "redux";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { getMySqlDate } from "../utils/Date";
import moment from "moment";
import { ReactComponent as IconLink } from "assets/Component 275 – 1.svg";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";

const StyledCol = styled(Col)`
  padding: 10px;
  .ant-card {
    border-radius: 10px !important;
  }
`;
const StyledWrap = styled.div`
  .ant-table-tbody > tr > td {
    font-weight: 400 !important;
  }
`;
const StyledTitle = styled.div`
  padding-left: 10px;
  padding-bottom: 10px;
  .ant-row {
    display: flex;
    flex-direction: column;
  }
  .ant-tabs-ink-bar {
    background-color: #2d53da;
  }
  #rc-tabs-1-tab-1:hover,
  #rc-tabs-1-tab-2:hover {
    color: #2d53da;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2d53da !important;
  }
  .ant-tabs-tab {
    color: #b2beb5;
  }
`;
const HeaderRow = styled.div`
  margin-top: 6px;
  display: flex;
  justify-content: start;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  .copy-icon {
    cursor: pointer;
  }
`;
const StyledFilterRow = styled(Row)`
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  .custom-prefix-icon {
    color: #636980;
  }
  .people_font_style {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 20.83px;
  }
  .ant-select-selector {
    box-shadow: none !important;
    border: none !important;
  }
  .custom-select-container {
    border: 1px solid #c0c0c0;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding-left: 5px;
  }
  .custom-select .ant-select-selector {
    border: none !important;
    flex: 1;
    border-radius: 10px;
    padding-right: 50px;
  }
  .ant-select-selection-placeholder {
    color: #636980 !important;
  }
  .custom-dropdown-icon {
    color: #636980;
    width: 10px;
  }
  .count_cls {
    display: flex;
  }
  .selectbox {
    width: 100%;
    margin-left: 10px;
  }
  .select_div {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 12px;
  }
  .filter_row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-left: 150px;
  }
  .row_cls_style {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .filter_col {
    display: flex;
    gap: 15px;
    flex-direction: row;
    margin-right: 10px;
  }
  @media ${DEVICE.tablet} {
    .selectbox {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
`;
const StyleSubmitButton = styled(ButtonOutlined)`
  @media (max-width: 320px) {
    margin: 0 !important;
  }
`;
const StyledContainerRow = styled(Row)`
  padding-top: 20px;
  .loader_container {
    width: 100%;
    text-align: center;
  }
  .noEmployee {
    width: 100%;
    text-align: center;
    color: grey;
    margin-top: 10%;
  }
`;
const StyleddeactivateModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding: 35px 0px 20px 0px;
  }
  .ant-modal-content {
    box-shadow: 0px 0px 8px #00000029;
    border-radius: 5px;
  }
  .ant-modal-title {
    text-align: center;
    font-size: 16px;
  }
  .ant-modal-body {
    padding: 0px 0px 35px 0px;
  }
  .ant-modal-close-x {
    display: none;
  }
  .page-title-head {
    justify-content: center;
  }
  .ant-modal-footer {
    display: none;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
  }
  .ant-modal-content {
    box-shadow: 0px 0px 8px #00000029;
    border-radius: 5px;
  }
  .ant-modal-body {
    padding: 24px 0px 30px 0px;
  }
  .modal-body {
    justify-content: center;
    margin-top: 10px;
  }
  .ant-modal-close-x {
    color: #151515;
  }
  .modal-body-content {
    justify-content: center;
    font-size: 16px;
    color: #151515;
  }
  .ant-modal-footer {
    display: none;
  }
`;
const StyledButton = styled(Button)`
  width: 125px;
  color: white;
  background-color: #b7b7b7;
  border-radius: 5px;
  margin-left: 5%;
`;

function Employee({
  ClientId,
  updateUserList,
  menuList,
  userRoleId,
  type,
  clientId,
  userList,
  allDepartmentList,
  locationList,
}) {
  const { t } = useTranslation();
  const planType = jwtDecode(window.localStorage.getItem("token"))?.planType;
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const filters = useSelector(getFilters);
  const menuName = "employee";
  const initialFilter = filters[menuName];

  const [form] = Form.useForm();

  const [displayAddEmployeeModal, toggleAddEmployeeModal] = useState(false);
  const [displayEditEmployeeModal, toggleEditEmployeeModal] = useState(false);
  const [EmployeeDetails, setEmployeeDetails] = useState({});
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [displayEmployeeLoader, setdisplayEmployeeLoader] = useState(false);
  const [EmployeeList, setEmployeeList] = useState([]);
  const [deactivateEmployee, toggledeactivateEmployee] = useState(false);
  const [confirmdeactivateEmployee, toggleconfirmdeactivateEmployee] =
    useState(false);
  const [empId, setEmpId] = useState(0);
  const [employeeCSVlist, setEmployeeCSVlist] = useState([]);
  const [btnLoader, togglebtnLoader] = useState(false);
  const [employeeType, setEmployeeType] = useState("1");
  const [reportResponse, setReportResponse] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const [filterValues, setFilterValues] = useState({
    name: [],
    department: [],
    location: [],
    country: [],
  });

  const csvLinkEl = useRef();
  const containerRef = useRef(null);

  const employeeFilterList = useMemo(() => {
    if (!employeeType) return EmployeeList;
    return EmployeeList.filter((data) => data?.statusid == employeeType);
  }, [employeeType, EmployeeList]);

  const getFilterList = useCallback(() => {
    const { name, department, location, country } = filterValues;

    const hasFilter =
      name?.length > 0 ||
      department?.length > 0 ||
      location?.length > 0 ||
      country?.length > 0;

    if (!hasFilter) return employeeFilterList || [];

    return (employeeFilterList || []).filter((item) => {
      const nameMatch =
        name?.length > 0
          ? name.some((n) => String(item.userid) === String(n))
          : true;

      const countryMatch =
        country?.length > 0
          ? country.map(String).includes(String(item?.nationality))
          : true;

      const deptStrings = department.map(String);
      const departmentMatch =
        deptStrings.length > 0
          ? Array.isArray(item?.basedepartmentid)
            ? item.basedepartmentid.some((d) => deptStrings.includes(String(d)))
            : deptStrings.includes(String(item?.basedepartmentid))
          : true;

      const locStrings = location.map(String);
      const locationMatch =
        locStrings.length > 0
          ? Array.isArray(item?.baselocationid)
            ? item.baselocationid.some((l) => locStrings.includes(String(l)))
            : locStrings.includes(String(item?.baselocationid))
          : true;

      return nameMatch && countryMatch && departmentMatch && locationMatch;
    });
  }, [filterValues, employeeFilterList]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterValues, employeeType]);

  const filteredList = getFilterList();
  const startIndex =
    ((filteredList.length > pageSize ? currentPage : 1) - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const getDisplayList = () => filteredList.slice(startIndex, endIndex);

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    const newFilters = {
      name: values.name || [],
      department: values.department || [],
      location: values.location || [],
      country: values.country || [],
    };
    setFilterValues(newFilters);

    dispatch(setFilter(menuName, "name", newFilters.name));
    dispatch(setFilter(menuName, "department", newFilters.department));
    dispatch(setFilter(menuName, "location", newFilters.location));
    dispatch(setFilter(menuName, "country", newFilters.country));
  };

  useEffect(() => {
    if (initialFilter) {
      const restored = {
        name: initialFilter.name || [],
        department: initialFilter.department || [],
        location: initialFilter.location || [],
        country: initialFilter.country || [],
      };
      form.setFieldsValue(restored);
      setFilterValues(restored);
    }
  }, []);

  const getEmployeeList = async () => {
    try {
      setdisplayEmployeeLoader(true);
      const { response } = await CALL_API_WITH_HEADER(
        `add-users/${ClientId}`,
        "get",
        {},
        { menupath: currentPath === "/team" ? "hrresource" : "employee" }
      );
      const sorted = response.sort((a, b) =>
        a.fullname.localeCompare(b.fullname)
      );
      setEmployeeList(sorted);
    } catch (error) {
      console.log("[getEmployeeList] Error-->", error);
    } finally {
      setdisplayEmployeeLoader(false);
    }
  };

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      { fetch_master_data }
    );
    if (code === STATUS_CODE.SUCCESS && fetch_master_data) {
      updateUserList(userList);
    }
  };

  const handlegetpay = async () => {
    try {
      const response = await axios.get(
        `https://ydcyv0nrdg.execute-api.ap-south-1.amazonaws.com/Prod/employeeget/${ClientId}`,
        { headers: { tymeplusjwt: window.localStorage.getItem("token") || "" } }
      );
      setReportResponse(response?.data?.response);
    } catch (error) {
      console.error("Error fetching pay data:", error);
    }
  };

  useEffect(() => {
    getEmployeeList();
    handlegetpay();
  }, []);

  const ViewEmployee = (EmployeeObject, isViewOnly = false) => {
    toggleEditEmployeeModal(true);
    setEmployeeDetails({ ...EmployeeObject, isViewOnly });
  };

  const deletedEmployee = (EmpId) => {
    toggledeactivateEmployee(true);
    setEmpId(EmpId);
  };

  const deleteEmployee = async (employee_id) => {
    togglebtnLoader(true);
    await CALL_API(`add-users/${ClientId}`, "delete", {
      user_id: employee_id,
      status_id: "0",
      status_name: "inactive",
    });
    togglebtnLoader(false);
    toggledeactivateEmployee(false);
    toggleconfirmdeactivateEmployee(true);
    fetchMasterData();
    getEmployeeList();
  };

  const handleTabSelect = (key) => {
    setEmployeeType(key === 2 ? "0" : "1");
    setFilterValues({ name: [], department: [], location: [], country: [] });
    form.resetFields();
  };

  const prepareCSV = async () => {
    togglebtnLoader(true);
    const list = getFilterList();
    if (list?.length > 0) {
      setEmployeeCSVlist(
        reduce(
          list,
          (result, list) => {
            result.push({
              "User Id": list?.userid || "",
              "Employee ID": list?.employeeid || "",
              Name: list?.fullname || "",
              "Start Date":
                list?.startdate && moment(list.startdate).isValid()
                  ? moment(list.startdate).format("DD/MM/YYYY")
                  : "-",
              "Date of Birth":
                list?.dateofbirth && moment(list.dateofbirth).isValid()
                  ? moment(list.dateofbirth).format("DD/MM/YYYY")
                  : "-",
              "Overtime Status": list?.overtimestatus || "",
              Gender: list?.gender || "",
              Age: list?.age || "",
              "Marital Status": list?.maritalstatus || "",
              Nationality: list?.nationality || "",
              Address: list?.presentaddress || "",
              "Phone No": list?.phoneno || "",
              "Institute Name": list?.institutename || "",
              Degree: list?.degree || "",
              Specialization: list?.specialization || "",
              "Year of Completion":
                list?.yearofcompletion &&
                moment(list.yearofcompletion).isValid()
                  ? moment(list.yearofcompletion).format("DD/MM/YYYY")
                  : "-",
              "Company Name": list?.companyname || "",
              "Job Title": list?.jobtitle || "",
              "Professional Since":
                list?.professionalsince &&
                moment(list.professionalsince).isValid()
                  ? moment(list.professionalsince).format("DD/MM/YYYY")
                  : "-",
              "Hired Date":
                list?.hireddate && moment(list.hireddate).isValid()
                  ? moment(list.hireddate).format("DD/MM/YYYY")
                  : "-",
              Relevant: list?.relevant || "",
              "Employee Sponser": list?.employeesponser || "",
              "Job Description": list?.jobdescription || "",
              "Emergency Contact Name": list?.emergencycontactname || "",
              "Emergency Contact Number": list?.emergencycontactnumber || "",
              ...(list?.statusid === "0" && {
                "Terminated Date": list?.terminateddate
                  ? moment(list.terminateddate).format("DD/MM/YYYY")
                  : "",
              }),
            });
            return result;
          },
          []
        )
      );
      setTimeout(() => csvLinkEl.current.link.click());
    } else {
      message.error(t("No data available to download."));
    }
    togglebtnLoader(false);
  };

  const Menulist =
    menuList[userRoleId] || Object?.values(menuList)[0] || menuList;
  const filtermenulist = Menulist?.filter(
    (data) =>
      data.key !== "managerdashboard" &&
      data.key !== "hrdashboard" &&
      data.key !== "teamcalendar" &&
      data.key !== "allcalendar"
  );

  const uniqueLocationName = uniqBy(
    locationList
      ?.filter((val) => val?.login_from_anywhere !== 1)
      .map((item) => ({
        label: item?.location_name,
        value: item?.location_id,
      })),
    "value"
  );
  const uniqueDepartmentName = uniqBy(
    allDepartmentList?.map((item) => ({
      label: item?.department_name,
      value: item?.department_id,
    })),
    "value"
  );
  const uniqueCountryName = uniqBy(
    countryList?.map((item) => ({ label: item, value: item })),
    "value"
  );

  const uniqueName = uniqBy(
    employeeFilterList?.map((item) => ({
      label: item?.fullname,
      value: item?.userid,
    })),
    "value"
  );

  const linkToCopy =
    planType === "Basic"
      ? `https://www.hr.app-demo-basic-onboarding.foresyts.ai/?clientid=${ClientId}`
      : `https://www.hr.app-demo-lite-onboarding.foresyts.ai/?clientid=${ClientId}`;
  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => message.success(t("Link copied")))
      .catch(() => message.error(t("Failed to copy link")));
  };

  const headerstyle = { fontSize: "20px", fontWeight: "bold" };

  const items1 = [
    { key: 1, label: t("Employee"), component: <></> },
    { key: 2, label: t("Ex Employee"), component: <></> },
  ];

  const items = [
    {
      key: "1",
      label: (
        <Link
          onClick={() => toggleAddEmployeeModal(true)}
          className="fw-semibold"
        >
          {t("New Employee Form")}
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link to="pending-employee" className="fw-semibold">
          {t("Pending Employee")}
        </Link>
      ),
    },
  ];

  const CSVHeaders = [
    { label: t("User Id"), key: "User Id" },
    { label: t("Name"), key: "Name" },
    { label: t("Start Date"), key: "Start Date" },
    { label: t("Date of Birth"), key: "Date of Birth" },
    { label: t("Overtime Status"), key: "Overtime Status" },
    { label: t("Gender"), key: "Gender" },
    { label: t("Age"), key: "Age" },
    { label: t("Marital Status"), key: "Marital Status" },
    { label: t("Nationality"), key: "Nationality" },
    { label: t("Address"), key: "Address" },
    { label: t("Phone No"), key: "Phone No" },
    { label: t("Institute Name"), key: "Institute Name" },
    { label: t("Degree"), key: "Degree" },
    { label: t("Specialization"), key: "Specialization" },
    { label: t("Year of Completion"), key: "Year of Completion" },
    { label: t("Company Name"), key: "Company Name" },
    { label: t("Job Title"), key: "Job Title" },
    { label: t("Professional Since"), key: "Professional Since" },
    { label: t("Hired Date"), key: "Hired Date" },
    { label: t("Relevant"), key: "Relevant" },
    { label: t("Employee Sponser"), key: "Employee Sponser" },
    { label: t("Job Description"), key: "Job Description" },
    { label: t("Emergency Contact Name"), key: "Emergency Contact Name" },
    { label: t("Emergency Contact Number"), key: "Emergency Contact Number" },
    { label: t("Terminated Date"), key: "Terminated Date" },
  ];

  return (
    <>
      {!displayAddEmployeeModal && !displayEditEmployeeModal && (
        <>
          <Row className="page-title">
            <Col sm={24} md={12} style={headerstyle}>
              {t("List of Employee")}
            </Col>
            <Col sm={24} md={12} className="align-right">
              {Menulist?.find(
                (item) =>
                  item?.key === "manage" &&
                  item?.subMenu?.find(
                    (subItem) =>
                      subItem?.key === "employee" && subItem?.permission.edit
                  )
              ) && (
                <ButtonFilled onClick={() => toggleAddEmployeeModal(true)}>
                  <span>+</span>
                  <span className="add-title">{t("Add People")}</span>
                </ButtonFilled>
              )}
            </Col>
          </Row>

          <StyledTitle className="page-title-head">
            <Row>
              <Tabs
                defaultActiveKey="1"
                items={items1}
                onChange={handleTabSelect}
                indicator={{ size: (origin) => origin - 20, align: "center" }}
              />
            </Row>
          </StyledTitle>

          <>
            <Row>
              <Col sm={24}>
                <StyledWrap>
                  <Form
                    form={form}
                    layout="vertical"
                    className="mt-2"
                    onValuesChange={handleFormChange}
                    initialValues={{ ...initialFilter }}
                  >
                    <Row gutter={12} className="g-3 mb-2">
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={8}
                        xl={6}
                        ref={containerRef}
                      >
                        <DropdownCheckBox
                          name="name"
                          label={t("People")}
                          options={uniqueName}
                          form={form}
                          handleFormChange={handleFormChange}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={8}
                        xl={6}
                        ref={containerRef}
                      >
                        <DropdownCheckBox
                          name="department"
                          label={t("Department")}
                          options={uniqueDepartmentName}
                          form={form}
                          handleFormChange={handleFormChange}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                        <DropdownCheckBox
                          name="location"
                          label={t("Location")}
                          options={uniqueLocationName}
                          form={form}
                          handleFormChange={handleFormChange}
                        />
                      </Col>
                    </Row>
                  </Form>
                </StyledWrap>
              </Col>
            </Row>

            <HeaderRow>
              <div className="people_font_style">
                {t("Total People")}: {filteredList?.length}
              </div>
              <CSVLink
                header={CSVHeaders}
                data={employeeCSVlist}
                filename={"Employee-list.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
              <StyleSubmitButton className="m-0 ms-auto" onClick={prepareCSV}>
                <span className="add-title">{t("Export CSV File")}</span>
              </StyleSubmitButton>
              {Menulist?.find(
                (item) => item?.key === "employee" && item?.permission.create
              ) && (
                <>
                  <IconLink className="copy-icon" onClick={handleCopyClick} />
                  <Dropdown
                    menu={{ items }}
                    placement="bottom"
                    trigger={["hover"]}
                  >
                    <ButtonFilled className="apply-leave-sm m-0">
                      {t("Add People")}
                    </ButtonFilled>
                  </Dropdown>
                </>
              )}
            </HeaderRow>

            <StyledContainerRow gutter={16}>
              {displayEmployeeLoader ? (
                <div className="loader_container">
                  <Spin spinning={displayEmployeeLoader} />
                </div>
              ) : (
                <>
                  {filteredList?.length > 0 ? (
                    map(getDisplayList(), (data, index) => (
                      <StyledCol
                        key={data.userid || index}
                        xs={24}
                        sm={12}
                        md={12}
                        lg={8}
                        xl={6}
                      >
                        <Link
                          to={`/profile-details/${data.userid}/?type=manage`}
                        >
                          <EmployeeCard
                            id={data.userid}
                            name={data.fullname}
                            Department={data.department_name}
                            clientid={data.clientid}
                            employeeid={data.employeeid}
                            data={data}
                            getEmployeeList={fetchMasterData}
                            ViewEmployee={ViewEmployee}
                            deletedEmployee={deletedEmployee}
                            profile={data.profileurl}
                            employeeType={employeeType}
                            rolename={data.rolename}
                          />
                        </Link>
                      </StyledCol>
                    ))
                  ) : (
                    <p className="noEmployee">
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </p>
                  )}
                </>
              )}
            </StyledContainerRow>

            {filteredList?.length > pageSize && (
              <Pagination
                current={currentPage}
                total={filteredList?.length}
                pageSize={pageSize}
                onChange={(page) => setCurrentPage(page)}
                style={{ marginTop: "20px", textAlign: "center" }}
                showSizeChanger
                onShowSizeChange={(_, size) => {
                  setPageSize(size);
                  setCurrentPage(1);
                }}
              />
            )}
          </>
        </>
      )}

      {displayAddEmployeeModal && (
        <AddEmployee
          isModalVisible={displayAddEmployeeModal}
          closeModal={() => toggleAddEmployeeModal(false)}
          getEmployeeList={getEmployeeList}
          setSelectedDepartment={setSelectedDepartment}
          EmployeeList={EmployeeList}
        />
      )}
      {displayEditEmployeeModal && (
        <EditEmployee
          isModalVisible={displayEditEmployeeModal}
          closeModal={() => toggleEditEmployeeModal(false)}
          getEmployeeList={getEmployeeList}
          EmployeeDetails={EmployeeDetails}
          EmployeeList={EmployeeList}
        />
      )}

      <StyleddeactivateModal
        title={t("Are you sure you want to terminate this Employee?")}
        visible={deactivateEmployee}
        width={500}
        onCancel={() => toggledeactivateEmployee(false)}
        footer={[]}
        centered
      >
        <Row className="page-title-head" gutter={16}>
          <Col>
            <StyledButton
              type="primary"
              htmlType="submit"
              onClick={() => toggledeactivateEmployee(false)}
            >
              {t("No")}
            </StyledButton>
          </Col>
          <Col>
            <StyledButton
              loading={btnLoader}
              type="primary"
              htmlType="submit"
              onClick={() => deleteEmployee(empId)}
            >
              {t("Yes")}
            </StyledButton>
          </Col>
        </Row>
      </StyleddeactivateModal>

      <StyledModal
        visible={confirmdeactivateEmployee}
        width={500}
        onCancel={() => toggleconfirmdeactivateEmployee(false)}
        footer={[]}
        centered
      >
        <Row className="modal-body">
          <Col>
            <img src={Confirm} alt="confirm" height={45} width={45} />
          </Col>
        </Row>
        <Row className="modal-body-content">
          <Col>
            <p>{t("This Employee has been terminated")}</p>
          </Col>
        </Row>
      </StyledModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userList: getUserList(state),
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  departmentUserList: getDepartmentUserList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  locationList: getLocations(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updateUserList: setUserList }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps, null)(Employee);
